export default "__VITE_ASSET__CYA3Bh8i__"